var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParticleone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 282,
    viewBox: "0 0 129 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.77,
    x: 128.667,
    y: 276,
    width: 10.4697,
    height: 10.4697,
    transform: "rotate(149 128.667 276)",
    fill: "#C44536",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.91,
    x: 28.3334,
    y: 189,
    width: 6.09976,
    height: 6.09976,
    transform: "rotate(57 28.3334 189)",
    fill: "#C44536",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.82,
    x: 116.667,
    y: 100.333,
    width: 6.28185,
    height: 6.28185,
    transform: "rotate(49 116.667 100.333)",
    fill: "#C44536",
    fillOpacity: 0.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.76,
    x: 78.3334,
    y: 159.333,
    width: 5.46248,
    height: 5.46248,
    transform: "rotate(-76 78.3334 159.333)",
    fill: "#C44536",
    fillOpacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.88,
    x: 93.6667,
    y: 11.6666,
    width: 10.7429,
    height: 10.7429,
    transform: "rotate(176 93.6667 11.6666)",
    fill: "#C44536",
    fillOpacity: 0.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.72,
    x: 0.333374,
    y: 29.6666,
    width: 5.55352,
    height: 5.55352,
    transform: "rotate(-31 0.333374 29.6666)",
    fill: "#C44536",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticleone);
export default __webpack_public_path__ + "static/media/particleone.8df6fd07e6000470ee1bb6f72f0c4654.svg";
export { ForwardRef as ReactComponent };